/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'file-document-edit': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M6 2c-1.11 0-2 .89-2 2v16a2 2 0 002 2h4v-1.91L12.09 18H6v-2h8.09l2-2H6v-2h12.09L20 10.09V8l-6-6H6m7 1.5L18.5 9H13V3.5m7.15 9.5a.55.55 0 00-.4.16l-1.02 1.02 2.09 2.08 1.02-1.01c.21-.22.21-.58 0-.79l-1.3-1.3a.544.544 0 00-.39-.16m-2.01 1.77L12 20.92V23h2.08l6.15-6.15-2.09-2.08z"/>'
  }
})
